<template>
    <mu-card class="cardDetails">
      <div class="img" :style="{backgroundImage:  `url('${image}')`}">
      </div>
      <div class="cardText">
        <h3>{{title}}</h3>
        <p>{{text}}</p>
        <ul>
          <li v-for="item in list">{{item}}</li>
        </ul>
        <mu-flat-button
          class="button"
          :label="buttonText"
          @click="goToArticle(buttonLink)"
        >
          <font-awesome-icon icon="info-circle" />
        </mu-flat-button>
      </div>
    </mu-card>
</template>

<script>
  export default {
    name: "CoachingCards",
    props: {
      image: String,
      title: String,
      text: String,
      list: Array,
      buttonText: String,
      buttonLink: String,
    },
    data () {
      return {
      }
    },
    methods: {
      goToArticle(path) {
        let self = this;
        self.$router.push({
          path: path
        })
      }
    },
    computed: {
    },
  }
</script>

<style lang="less" scoped>
@import "../../styles/theme";

@themeColour: #0176d0;
@poppinsFont: 'Poppins', sans-serif;

.cardDetails {
  box-shadow: none;
  border: 1px solid rgba(91,97,124,.11);
  border-radius: 8px 8px 1.5rem;
  @media screen and (max-width: 1000px) {
    margin: 1rem 0;
    min-height: auto!important;
  }
  .img {
    border-radius: 8px 8px 0 0;
    -moz-border-radius: 8px 8px 0 0;
    -webkit-border-radius: 8px 8px 0 0;
    width: 100%;
    min-height: 270px;
    background-position: center center;
    background-size: cover;
  }
  .cardText {
    padding: 16px 24px;
    min-height: 290px;
    @media screen and (max-width: 1000px) {
      min-height: 100%;
    }
    h3 {
      margin: 0;
      color: @themeColour;
      font-family: @poppinsFont;
      font-size: 1.2rem;
      line-height: 1.4;
      font-weight: 600;
    }
    p {
      margin: 10px 0 15px;
      font-weight: 400;
      color: #000;
    }
    ul {
      padding-left: 0;
      li {
        padding-left: 36px;
        background-image: url('../../../static/pw/tick_active.svg');
        background-repeat: no-repeat;
        background-position: 0 20%;
        background-size: 1.3rem;
        font-family: @poppinsFont;
        font-size: 1rem;
        line-height: 1.4;
        list-style-type: none;
        font-weight: 400;
        color: #000;
      }
    }
    .button {
      text-transform: none;
      height: 40px;
      margin-top: 8px;
      background-color: @themeColour;
      width: 100%;
      color: #FFF;
      border-radius: 8px;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      font-size: 1rem;
      font-family: @poppinsFont;
      svg {
        font-size: 16px;
      }
      &:hover {
        box-shadow: 0 4px 12px 8px #5b617c1a;
        -webkit-transform: translate(0,-2px);
        -ms-transform: translate(0,-2px);
        transform: translate(0,-2px);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// CoachingCard.vue?5b30e81f